"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionLimitErrMsg = exports.SECTIONS_PER_COOKBOOK_LIMIT = exports.cookbookLimitErrMsg = exports.COOKBOOK_LIMIT = exports.importRecipeMissingInstructionsOrIngredientsMessage = exports.deleteRecipeMessage = exports.groceryListModalSucess = exports.MAX_RECIPES_TO_GROCERY_LIST = exports.STRIPE_CHARGE_ERROR = exports.FREE_TRIAL_EXPIRED_ERROR = exports.DOES_NOT_EXIST = exports.NOT_HOMECOOK_ERROR = exports.NOT_AUTHORIZED_ERROR = exports.NOT_AUTHENTICATED_ERROR = void 0;
exports.NOT_AUTHENTICATED_ERROR = "not authenticated";
exports.NOT_AUTHORIZED_ERROR = "not authorized";
exports.NOT_HOMECOOK_ERROR = "not homecook";
exports.DOES_NOT_EXIST = "does not exist";
exports.FREE_TRIAL_EXPIRED_ERROR = "free trial expired";
exports.STRIPE_CHARGE_ERROR = "unable to charge card";
exports.MAX_RECIPES_TO_GROCERY_LIST = 300;
exports.groceryListModalSucess = "Ingredients added to your grocery list.";
exports.deleteRecipeMessage = "Are you sure you want to delete this recipe forever?";
exports.importRecipeMissingInstructionsOrIngredientsMessage = "Weren't able to find entire recipe, here's what we got";
exports.COOKBOOK_LIMIT = 25;
exports.cookbookLimitErrMsg = `You've reached the max of ${exports.COOKBOOK_LIMIT} cookbooks.`;
exports.SECTIONS_PER_COOKBOOK_LIMIT = 35;
exports.sectionLimitErrMsg = `This cookbook can't have more than ${exports.SECTIONS_PER_COOKBOOK_LIMIT} sections.`;
//# sourceMappingURL=messages.js.map